import { brand } from "./brand.config";

/**
 * Loyalty card copy and the card URL (specs/006-loyalty, Principle VI).
 *
 * Everything a customer or cashier reads about the card lives here, so a
 * different café rebrands it by editing this file and touching no component.
 *
 * `cardBaseUrl` is printed on plastic. Once a batch has gone to the printer it
 * must never change (research R1, R2; CLAUDE.md).
 */
export const loyaltyTheme = {
  cardBaseUrl: "https://hintodaily.co/c/",
  cardName: `${brand.identity.logo.wordmarkText} card`,
  businessName: brand.identity.businessName,
  rewardEvery: 10,
  rewardDescription: "a free drink or pastry",
  rewardLineLabel: "Loyalty reward",

  till: {
    scan: "Scan card",
    typeHint: "Or type the code under the QR",
    notACard: `This isn't a ${brand.identity.logo.wordmarkText} card`,
    badCheck: "That code isn't valid — check it and try again",
    badLength: "A card code is 11 characters, like K7M2-QX9P-AB3",
    blocked: "This card is blocked. Ask a manager.",
    retired: "This card is no longer valid",
    noCamera: "This tablet can't scan QR codes — type the code instead",
    cameraDenied: "The camera isn't available — type the code instead",
    rewardReady: "Reward ready",
  },

  page: {
    title: (businessName: string) => `Your ${businessName} card`,
    more: (n: number) => (n === 1 ? "1 more for a free drink or pastry" : `${n} more for a free drink or pastry`),
    ready: (n: number) =>
      n === 1 ? "1 reward ready — a free drink or pastry, your choice" : `${n} rewards ready — a free drink or pastry each`,
    howToEarn: "Every drink earns a sticker. Ten stickers earn a free drink or pastry, your choice.",
    updated: "Updated",
    showAtCounter: "Show this card at the counter to collect stickers.",
    invalidTitle: `This isn't a valid ${brand.identity.logo.wordmarkText} card`,
    invalidBody: "Check the code, or ask at the counter.",
  },
} as const;

export function formatPesos(centavos: number): string {
  return new Intl.NumberFormat(brand.locale.locale, {
    style: "currency",
    currency: brand.locale.currencyCode,
    minimumFractionDigits: brand.locale.minorUnits,
  }).format(centavos / 10 ** brand.locale.minorUnits);
}
